import { KbCookies } from "./../../kb-cookies";
import { ActionTree } from "vuex";
import axios from "axios";
import { UserState } from "./types";
import { RootState } from "../types";

function handleLoginResponse(commit: any, rememberMe: boolean, res: any) {
  const data = res.data;
  if (data.length === 0) {
    commit("userReset");
    throw "login";
  }

  commit("userLoaded", data);

  if (rememberMe) {
    KbCookies.setCookie("cookieUser[id]", data.id, 7);
    KbCookies.setCookie("cookieUser[rt]", data.token, 7);
  } else {
    KbCookies.setCookie("cookieUser[id]", data.id);
    KbCookies.setCookie("cookieUser[rt]", data.token);
  }
}

export const actions: ActionTree<UserState, RootState> = {
  async logUserByLoginAndPassword({ commit }, { login, password, rememberMe }) {
    const res = await axios.post("/api/user/session", {
      login: login,
      password: password
    });

    handleLoginResponse(commit, rememberMe, res);
  },

  async logUserByToken({ commit }, { token }) {
    const res = await axios.post("/api/user/session", {
      token: token
    });

    handleLoginResponse(commit, true, res);
  },

  logOut({ commit }) {
    KbCookies.removeCookie("cookieUser[id]");
    KbCookies.removeCookie("cookieUser[rt]");

    commit('userReset');

    /* BUGFIX 1609: Call KB2018 disconnection URI in order to also destroy the session for KB2018 */
    axios.get('/deconnecter.php');
  },

  async getUnreadMessagesCount({ commit }, { token }) {
    const res = await axios.get("/api/user/unreadMessagesCount", {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    });

    if (res.status === 403) {
      commit('userReset');
      return;
    }

    commit('setUnreadMessagesCount', res.data);
  },

  async getUnreadNotificationsCount({ commit }, { token }) {
    const res = await axios.get("/api/user/unreadNotificationsCount", {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    });

    if (res.status === 403) {
      commit('userReset');
      return;
    }

    commit('setUnreadNotificationsCount', res.data);
  },
};
